import { Box, styled, StyleSystemProps, TextV2 } from '@withjoy/joykit';
import { CSSObject } from '@withjoy/joykit/components/Box/Box.types';
import { animationTransition } from '@shared/utils/animationTransition';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledContainer = styled(Box)``;
export const StyledTitle = styled(TextV2)``;
export const StyledItemsContainer = styled(Box)``;
export const StyledItemContainer = styled(Box)``;
export const StyledItemTitle = styled(TextV2)``;
export const StyledItemIcon = styled(Box)``;

const titleStyles: StyleSystemProps = {
  marginBottom: {
    _: '32px',
    md: '34px',
  },
  textAlign: 'center',
};

const containerStyles: CSSObject = {
  padding: '35px 0px 85px 0px',
  width: 'fill-available',
  position: 'relative',

  _before: {
    position: 'absolute',
    content: '" "',
    height: '1px',
    width: '100%',
    top: 0,
  },
  _after: {
    position: 'absolute',
    content: '" "',
    height: '1px',
    width: '100%',
    bottom: '-1px',
  },
};

const itemContainerStyles: StyleSystemProps = {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  maxWidth: pxToRem(122),
  textAlign: { _: 'center', md: 'left' },
  transition: animationTransition('color'),
  _hover: {
    color: 'mono11',
    _active: {
      color: '#000',
    },
  },
};

const itemTitleStyles: StyleSystemProps = {
  textAlign: 'center',
  lineHeight: '18px',
};

const itemIconStyles: CSSObject = {
  height: '42px',
  display: 'flex',
  alignItems: 'center',
  ['> svg ']: {
    height: '22px',
  },
};

export const styles = {
  title: titleStyles,
  container: containerStyles,
  itemContainer: itemContainerStyles,
  itemTitle: itemTitleStyles,
  itemIcon: itemIconStyles,
};
